<template>
  <div class="col-sm-6" style="padding-right: 0;">
    <input
      class="form-control form-control-sm"
      v-bind:id="filter.id"
      v-model="filter.value"
      v-on:input="emitToggleEvent()"
    />
  </div>
</template>

<script>
export default {
  name: 'InputFilter',
  props: ['filter'],
  data: function() {
    return {
      data: ''
    };
  },
  beforeMount() {},
  methods: {
    emitToggleEvent() {
      this.$emit('toggle-value');
    }
  }
};
</script>
